import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: false,
  user: null,
  userId: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.userId = action.payload.id;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.userId = null;
    },
  },
});

export const { setUser, logout } = authSlice.actions;
export default authSlice.reducer;
